import { pageFactory } from '../../support';

export const QueryTab = pageFactory({
  url: '',
  selectors: {
    scenarioSelect: 'Test Data Query scenario select',
  },
});
